import React, { useState } from 'react'
import { shorterDate, formatPrice } from '../helper/functions';
import TabButton from './TabButton';
import MyWallet from './MyWallet';
import { useStakeStats } from '../hooks/useBscAccount';
import { ClipLoader } from 'react-spinners';
import { DECIMALS, SYMBOL } from '../helper/constant';
import Chip from '@mui/material/Chip';


export default function Unstake({ accStats, setTab, tab }) {
    const [page, setPage] = useState(1)
    const stakeStats = useStakeStats(page)

    const override = {
        display: "block",
        marginRight: "auto",
        marginLeft: "auto"
    };

    return (
        <div className='row mb-4 d-flex justify-content-center'>
            <div className='col-12 col-xl-7'>
                <TabButton setTab={setTab} tab={tab} />
                <div className='table-responsive'>
                    <table class="table table-bordered border-primary table-unstake">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Amount (BNB)</th>
                                <th scope="col">Token Amount ({SYMBOL})</th>
                                <th scope="col">Start</th>
                                <th scope="col">End</th>
                                <th scope="col">Earn</th>
                                <th scope="col">Claimed</th>

                            </tr>
                        </thead>
                        <tbody>
                            {stakeStats.loading ? (
                                <tr>
                                    <td colSpan={10} className='p-4'>
                                        <ClipLoader
                                            color="#fff"
                                            loading={true}
                                            cssOverride={override}
                                            size={50}
                                        // className="spinner"
                                        />
                                    </td>
                                </tr>
                            ) : (
                                stakeStats.stakeHistory && stakeStats.stakeHistory.length > 0 ? (
                                    stakeStats.stakeHistory.map((row, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{(page - 1) * 8 + index + 1}</td>
                                                <td>{row.bnbamount > 0 ? formatPrice(row.bnbamount / Math.pow(10, 18)) : ' - '}</td>
                                                <td>
                                                    {row.tokenamount ? formatPrice(row.tokenamount / Math.pow(10, DECIMALS)) : ' - '}
                                                    {row.bnbamount <= 0 && (
                                                        <span className="badge bg-success ms-2">compound</span> // Adjust badge classes as needed
                                                    )}
                                                </td>
                                                <td>{row.starttime ? shorterDate(row.starttime * 1000) : ' - '}</td>
                                                <td>{row.endtime ? shorterDate(row.endtime * 1000) : ' - '}</td>
                                                <td>{row.totalreward ? formatPrice(row.totalreward / Math.pow(10, DECIMALS)) : 0}</td>
                                                <td>
                                                    {row.claimed
                                                        ? <Chip sx={{height : "23px"}} label="claimed" color="error" />
                                                        : <Chip sx={{height : "23px"}} label="active" color="success" />
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })

                                ) : (
                                    <tr>
                                        <td colSpan={10}>
                                            <h5 className="p-5 text-white text-center">You Have No Earn Record Yet.</h5>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    <div className='d-flex justify-content-end mb-3'>
                        {
                            parseInt(page) > 1 &&

                            <button className='btn btn-sm btn-outline-light mx-2' onClick={() => {
                                setPage(page - 1);

                            }}>
                                Prev
                            </button>


                        }
                        {parseInt(page) < parseInt(stakeStats.totalPages) &&

                            <button className='btn btn-sm btn-outline-light mx-2' onClick={() => {
                                setPage(page + 1);

                            }}>
                                Next
                            </button>

                        }
                    </div>
                </div>
            </div>
            <MyWallet accStats={accStats} />
        </div>


    )
}
